<script>
export default {

  props: {
    collection: {
      type: Array,
      required: true
    },

    value: {}
  },

  data() {
    return {
      selectedValues: [this.value]
    }
  },

  watch: {
    selectedValues() {
      if (this.selectedValues.length > 1) {
        this.selectedValues = this.selectedValues.slice(1)
      }
      // select field might be cleared due to filtering; ignore null values
      if (!this.selectedValues[0]) {
        return
      }
      this.$emit("input", this.selectedValues[0])
    }
  }

}
</script>

<template>
  <b-select multiple native-size="8" v-model="selectedValues" expanded>
    <option :value="template.uuid" v-for="template in collection">{{ template.name }}</option>
  </b-select>
</template>

<style lang="scss" scoped>
select {
  min-height: 300px;
}
option{
  white-space: pre-wrap;
}
</style>